import React from 'react';
import {
  FDPrimaryActionButton,
  FDStack,
  FDAvatar,
  FDBodyText, FDCard, FDBox,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { facetFacUrl } from 'Consts/logo';

const ActionCard = (props) => {
  const {
    avatarSrc,
    avatarAlt,
    text,
    buttonLabel,
    buttonOnClick,
  } = props;
  return (
    <FDCard>
      <FDBox padding={1}>
        <FDStack direction={'row'} spacing={4} alignItems={'center'}>
          <FDAvatar alt={avatarAlt} src={avatarSrc} size={'sm'} />
          <FDStack flexGrow={1} direction={'row'} spacing={4} justifyContent={'space-between'} alignItems={'center'}>
            <FDBodyText value={text} size={'md'} />
            <FDPrimaryActionButton label={buttonLabel} size={'sm'} flexShrink={0} onClick={buttonOnClick} />
          </FDStack>
        </FDStack>
      </FDBox>
    </FDCard>
  );
};

ActionCard.defaultProps = {
  avatarSrc: facetFacUrl,
  avatarAlt: '',
  text: '',
  buttonLabel: 'Get started',
  buttonOnClick: () => {},
};

ActionCard.propTypes = {
  avatarSrc: PropTypes.string,
  avatarAlt: PropTypes.string,
  text: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonOnClick: PropTypes.func,
};

export default ActionCard;
